<template>
  <v-container class="mx-0 px-0">
    <h1 class="text-center title">Mode: <span class="title grey--text text--ligthen-4">{{mode}}</span></h1>

    <p class="text-center">
      {{assess.length}} |
      {{learn.length}} |
      {{review.length}} |
      {{know.length}}
    </p>



    <div v-if="assess && mode !='done'">
      <v-card id="assess" class="mb-0 py-1 text-center"  @click="showAnswer = !showAnswer">

        <v-card flat>
          <div v-html="currentCard.question" class="blue--text title py-5">
          </div>
          <img class="image-size" v-if="getSRC(currentCard.question)[0]" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_pepper/' + getSRC(currentCard.question)[0]"/>
          <div v-html="currentCard.answer" v-if="showAnswer" class="py-5">
          </div>
          <div v-if="showAnswer" >
            <img class="py-5 image-size" v-for="(i, z) in getSRC(currentCard.images)" :key="z" :src="'https://omentum.s3.us-east-1.amazonaws.com/anki_pepper/' + i"/>
          </div>
          <v-card class="pa-5 ma-5">
            .
          </v-card>
        </v-card>
      </v-card>
      <!-- <v-card class="ma-5 mt-0 pa-5 text-center">
        <v-layout v-if="showAnswer">
          <v-flex >
            <v-btn @click="processResult(currentCard.id, false, mode)"  class="ma-5" x-large icon color="purple"><v-icon x-large>mdi-thumb-down</v-icon></v-btn>
            <v-btn @click="processResult(currentCard.id, true, mode)" class="ma-5" x-large icon color="blue"><v-icon x-large>mdi-thumb-up</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card> -->
    </div>
    <div id="footer" background-color="orange" color="black" fixed v-if="showAnswer">
      <v-layout>
        <v-flex>
          <v-btn @click="processResult(currentCard.id, false, mode)" class="ma-3"  x-large dark color="purple"><v-icon x-large>mdi-thumb-down</v-icon></v-btn>
          <v-btn @click="processResult(currentCard.id, true, mode)" class="ma-3" x-large dark color="blue"><v-icon x-large>mdi-thumb-up</v-icon></v-btn>
        </v-flex>
      </v-layout>

    </div>


    <div v-if="mode =='done'">
      <v-card id="assess" class="ma-5 mb-0 pa-5 text-center">
        <h1>Learning Complete!</h1>
        <v-btn text color="orange" @click="$router.push({name: 'Anki'})">< Return to Content</v-btn>
      </v-card>
    </div>








  </v-container>
</template>

<script>
import adm from './algoDataModel.js'




export default {
  name: 'algoPrototype',
  data() {
    return {
      assess: null,
      learn: null,
      review: null,
      know: null,
      showAnswer: false,
      mode: 'assess',
      deckData: null,
    }
  },
  computed: {
    currentCard() {
      if (this.assess) {
        if (this.assess.length > 0) {
          this.mode = "assess"
          console.log('assess')
          return this.assess[0]
        }
        else if (this.learn.length > 0) {
          this.mode = "learn"
          console.log('learn')

          return this.learn[0]
        }
        else if (this.review.length > 0) {
          this.mode = "review"
          console.log('review')

          return this.review[0]
        }
        else if (this.review.length == 0) {
          this.mode = "done"
          this.deckData.endTime = new Date()
          console.log('done')
          return null

        }
        else {
          return null
        }

      }
      else {
        return null
      }
    }
  },
  created() {
    window.addEventListener('keyup', event => {
        if (event.key == '1' && this.showAnswer == true) {
          this.processResult('key', false, this.mode)
        }
        else if (event.key == '2' && this.showAnswer == true) {
          this.processResult('key', true, this.mode)
        }
        else if (event.key == ' ') {
          console.log('space')
          this.showAnswer = !this.showAnswer

        }

    })
  },
  mounted() {
    console.log('test', this.$route.params)
    this.setUpDecks()
    this.deckData = adm.initDeck()






  },
  methods: {
    setUpDecks() {
      this.assess = []
      if (this.$route.params.cards) {
        this.assess = this.$route.params.cards
      }
      else {
        JSON.parse(JSON.stringify(adm.content)).forEach(item => {this.assess.push(item)})
      }


      this.learn = []
      this.review = []
      this.know = []
    },
    processResult(id, value, mode) {
      console.log(id, value, mode)
      let modes = ['assess', 'learn', 'review', 'know']
      this.showAnswer = false
      let i = modes.indexOf(mode)
      let card = this[modes[i]].shift()
      if (mode == 'assess') {

        if (value) {
          this[modes[i+2]].push(card)
        }
        else {
          this[modes[i+1]].push(card)

        }
      }
      else if (value) {
        this[modes[i+1]].push(card)
      }
      else {
        this[modes[i]].push(card)
      }
    },
    getSRC(str){
      var m,
          urls = [],
          rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;

      while ( m = rex.exec( str ) ) {
          urls.push( m[1] );
      }
      return urls

    }

  }
}
</script>

<style>
.image-size {
  width: 100%;
  max-width: 500px;

}
#footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    border: 2px solid orange;
    background: white;
    text-align: center;
}

</style>
